import { render, staticRenderFns } from "./reports-legend-years.vue?vue&type=template&id=3421a6af&scoped=true"
import script from "./reports-legend-years.vue?vue&type=script&lang=js"
export * from "./reports-legend-years.vue?vue&type=script&lang=js"
import style0 from "./reports-legend-years.vue?vue&type=style&index=0&id=3421a6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421a6af",
  null
  
)

export default component.exports